import brgI18n from '@/locales';
import { numberToFormatted, validateTextWithHypen, } from '@/utils';
export class WorkerMonthlyAttendanceSumData {
    _sumData;
    constructor(sumData) {
        this._sumData = sumData;
    }
    /** 월근무시간(왼쪽-분) */
    get formattedSumWorkingMinute() {
        const { sumWorkingMinute } = this._sumData;
        if (!sumWorkingMinute) {
            return validateTextWithHypen(sumWorkingMinute);
        }
        const sumWorkingMinuteWithSuffix = brgI18n.global.t('common.minutes_suffix', {
            minutes: numberToFormatted(sumWorkingMinute),
        });
        return validateTextWithHypen(sumWorkingMinuteWithSuffix);
    }
    /** 월근무시간(오른쪽-시간) */
    get formattedSumWorkingHour() {
        const { sumWorkingHour } = this._sumData;
        if (!sumWorkingHour) {
            return validateTextWithHypen(sumWorkingHour);
        }
        const sumWorkingHourWithSuffix = brgI18n.global.t('common.hours_suffix', {
            hours: numberToFormatted(sumWorkingHour),
        });
        return validateTextWithHypen(sumWorkingHourWithSuffix);
    }
    /** 월근무일수 */
    get formattedSumWorkingCount() {
        const { sumWorkingCount } = this._sumData;
        if (!sumWorkingCount) {
            return validateTextWithHypen(sumWorkingCount);
        }
        const sumWorkingCountWithSuffix = brgI18n.global.t('unit.day_suffix', {
            day: numberToFormatted(sumWorkingCount),
        });
        return validateTextWithHypen(sumWorkingCountWithSuffix);
    }
    /** 월완료건수 */
    get formattedSumDeliveryCount() {
        const { sumDeliveryCount } = this._sumData;
        if (!sumDeliveryCount) {
            return validateTextWithHypen(sumDeliveryCount);
        }
        const sumDeliveryCountWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(sumDeliveryCount),
        });
        return validateTextWithHypen(sumDeliveryCountWithSuffix);
    }
    /** 일평균근무시간(시간단위임) */
    get formattedAvgWorkingMinute() {
        const { avgWorkingMinute } = this._sumData;
        if (!avgWorkingMinute) {
            return validateTextWithHypen(avgWorkingMinute);
        }
        const avgWorkingMinuteWithSuffix = brgI18n.global.t('common.hours_suffix', {
            hours: numberToFormatted(avgWorkingMinute, {
                style: 'decimal',
            }),
        });
        return validateTextWithHypen(avgWorkingMinuteWithSuffix);
    }
    /** 일평균완료건수 */
    get formattedAvgDeliveryCount() {
        const { avgDeliveryCount } = this._sumData;
        if (!avgDeliveryCount) {
            return validateTextWithHypen(avgDeliveryCount);
        }
        const avgDeliveryCountWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(avgDeliveryCount),
        });
        return validateTextWithHypen(avgDeliveryCountWithSuffix);
    }
    /** 시간당완료건수 */
    get formattedAvgDeliveryCountByHour() {
        const { avgDeliveryCountByHour } = this._sumData;
        if (!avgDeliveryCountByHour) {
            return validateTextWithHypen(avgDeliveryCountByHour);
        }
        const avgDeliveryCountByHourWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(avgDeliveryCountByHour),
        });
        return validateTextWithHypen(avgDeliveryCountByHourWithSuffix);
    }
    /** 시간범위근무시간(분단위임) */
    get formattedSumWorkingMinuteInPeriod() {
        const { sumWorkingMinuteInPeriod } = this._sumData;
        if (!sumWorkingMinuteInPeriod) {
            return validateTextWithHypen(sumWorkingMinuteInPeriod);
        }
        const sumWorkingMinuteInPeriodWithSuffix = brgI18n.global.t('common.minutes_suffix', {
            minutes: numberToFormatted(sumWorkingMinuteInPeriod),
        });
        return validateTextWithHypen(sumWorkingMinuteInPeriodWithSuffix);
    }
    /** 시간범위완료건수 */
    get formattedSumDeliveryCountInPeriod() {
        const { sumDeliveryCountInPeriod } = this._sumData;
        if (!sumDeliveryCountInPeriod) {
            return validateTextWithHypen(sumDeliveryCountInPeriod);
        }
        const sumDeliveryCountInPeriodWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(sumDeliveryCountInPeriod),
        });
        return validateTextWithHypen(sumDeliveryCountInPeriodWithSuffix);
    }
    /** 시간범위일평균근무시간(시간단위임) */
    get formattedAvgWorkingMinuteInPeriod() {
        const { avgWorkingMinuteInPeriod } = this._sumData;
        if (!avgWorkingMinuteInPeriod) {
            return validateTextWithHypen(avgWorkingMinuteInPeriod);
        }
        const avgWorkingMinuteInPeriodWithSuffix = brgI18n.global.t('common.hours_suffix', {
            hours: numberToFormatted(avgWorkingMinuteInPeriod),
        });
        return validateTextWithHypen(avgWorkingMinuteInPeriodWithSuffix);
    }
    /** 시간범위일평균완료건수 */
    get formattedAvgDeliveryCountInPeriod() {
        const { avgDeliveryCountInPeriod } = this._sumData;
        if (!avgDeliveryCountInPeriod) {
            return validateTextWithHypen(avgDeliveryCountInPeriod);
        }
        const avgDeliveryCountInPeriodWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(avgDeliveryCountInPeriod),
        });
        return validateTextWithHypen(avgDeliveryCountInPeriodWithSuffix);
    }
    /** 시간범위시간당완료건수 */
    get formattedAvgDeliveryCountInPeriodHour() {
        const { avgDeliveryCountInPeriodHour } = this._sumData;
        if (!avgDeliveryCountInPeriodHour) {
            return validateTextWithHypen(avgDeliveryCountInPeriodHour);
        }
        const avgDeliveryCountInPeriodHourWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(avgDeliveryCountInPeriodHour),
        });
        return validateTextWithHypen(avgDeliveryCountInPeriodHourWithSuffix);
    }
}
